var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 9 16",
    fill: "#00897D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01307 15.8187C7.93442 15.8187 7.85655 15.8031 7.7839 15.773C7.71126 15.7429 7.64528 15.6987 7.58974 15.643L0.376165 8.43046C0.264102 8.31807 0.201172 8.16583 0.201172 8.00712C0.201172 7.84841 0.264102 7.69618 0.376165 7.58379L7.58868 0.37126C7.70284 0.26873 7.85197 0.213875 8.00536 0.217989C8.15875 0.222104 8.30473 0.284874 8.41323 0.393376C8.52173 0.501878 8.5845 0.647852 8.58862 0.801242C8.59273 0.954633 8.53787 1.10376 8.43535 1.21792L1.64881 8.00606L8.43693 14.7942C8.52082 14.8781 8.57797 14.9849 8.60117 15.1012C8.62437 15.2175 8.61258 15.3381 8.56728 15.4478C8.52198 15.5574 8.44521 15.6511 8.34666 15.7171C8.24812 15.7832 8.13222 15.8185 8.0136 15.8187H8.01307Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.13d07bdf196e0ec5ba031a77a478171b.svg";
export { ForwardRef as ReactComponent };